import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CLStore} from 'common/src/redux/store';
import {CampaignSetupAgentToolName} from '../../../../campaignSetupAgent.enums';
import {creativeCardSchema} from '../../../../schemas/creativeCardSchema';
import addOrUpdateCardTool from '../../../../tools/general/addOrUpdateCardTool/addOrUpdateCardTool';
import getCreativeDetailsTool from './getCreativesTool';

export default function addOrUpdateCreativeCardTool(store: CLStore) {
  return addOrUpdateCardTool({
    store,
    cardType: NodeType.CREATIVE,
    cardSchema: creativeCardSchema,
    description: 'Add or update SINGLE Creative card. Can search for creatives by prompt.',
    tools: [getCreativeDetailsTool(store)],
    cardSpecificInstructions: `If a creative ID is provided, use it directly. Only use the ${CampaignSetupAgentToolName.GetCreatives} tool if no ID is provided or if the user provided other search details.`,
  });
}
